// Copyright (c) 2017 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import createClaimModal from './create-claim-modal';
import customer from './customer';
import isCustomerEditModalOpen from './customer-edit-modal-visibility';
import isCustomerSearchModalOpen from './customer-search-modal-visibility';
import partialData from './partial-data-warning';
import product from './product';
import products from './products';
import searchFilters from './search-filters';
import statusChangeModal from './status-change-modal';

export const getCombinedReducers = () => combineReducers({
    busyCounter,
    createClaimModal,
    customer,
    isCustomerEditModalOpen,
    isCustomerSearchModalOpen,
    partialData,
    product,
    products,
    searchFilters,
    statusChangeModal
});



// WEBPACK FOOTER //
// ./src/product/products-by-customer/reducers/index.js